import React from 'react';
import { motion } from 'framer-motion';
import { Package, MoreVertical, Calendar, DollarSign } from 'lucide-react';
import { ASSET_CATEGORIES, ASSET_STATUSES } from '../../data/mockData';

const RecentAssetsList = ({ assets, onSelectAsset }) => {
  const getStatusColor = (status) => {
    return ASSET_STATUSES[status]?.color || 'gray';
  };

  const getCategoryIcon = (categoryId) => {
    const category = ASSET_CATEGORIES.find(cat => cat.id === categoryId);
    const Icon = category?.icon || Package;
    return <Icon className="w-5 h-5" />;
  };

  return (
    <div className="divide-y divide-gray-100">
      {assets.map((asset) => (
        <motion.div
          key={asset.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="p-4 hover:bg-gray-50 transition-colors cursor-pointer"
          onClick={() => onSelectAsset(asset)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className={`p-2 bg-${getStatusColor(asset.status)}-100 rounded-lg`}>
                {getCategoryIcon(asset.category)}
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-900">{asset.name}</h3>
                <p className="text-xs text-gray-500">{asset.id}</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">
                  ${asset.currentValue.toLocaleString()}
                </p>
                <div className="flex items-center gap-1 text-xs text-gray-500">
                  <Calendar className="w-3 h-3" />
                  {new Date(asset.purchaseDate).toLocaleDateString()}
                </div>
              </div>
              <button 
                className="p-1 hover:bg-gray-100 rounded-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <MoreVertical className="w-4 h-4 text-gray-400" />
              </button>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default RecentAssetsList; 